/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_TitleInputs */

const et_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parim SEO/AI SEO Turundusagentuur Tallinn`)
};

const en_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best SEO / AI SEO Marketing Agency in Tallinn`)
};

/**
* | output |
* | --- |
* | "Best SEO / AI SEO Marketing Agency in Tallinn" |
*
* @param {Meta_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const meta_title = /** @type {((inputs?: Meta_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_meta_title(inputs)
	return en_meta_title(inputs)
});